
import React, { useCallback } from 'react';
import { JiraProjectData } from '../../../../../api/endpoints/jira';
import { Copy, Flexer } from '../../../../dashboard/elements/LayoutElements';
import { SelectJiraProjectView } from '../../../../external/atlassian/SelectJiraProjectView';
import { useAssitantToolCallResult, useSubmitToolResult } from '../../AssistantHooks';
import { AssitantToolSupport } from '../../AssistantToolSupport';
import { ToolCallPart } from '../../ChatTypes';

const InlineJiraProjectSelector = React.memo(({ toolCallId }: ToolCallPart) => {

    const submitToolResult = useSubmitToolResult();
    const toolResult = useAssitantToolCallResult(toolCallId) as any;

    const onSelect = useCallback((project: JiraProjectData) => {
        submitToolResult(toolCallId, {
            id: project.id,
            key: project.key,
            name: project.name,
        });
    }, []);

    if (toolResult) {
        return <Flexer>
            <Copy flush>Selected: {toolResult.name} [{toolResult.key}] ✓</Copy>
        </Flexer>;
    }

    return <Flexer flex height="20">
        <SelectJiraProjectView onSelect={onSelect} />
    </Flexer>;
});

export const GetJiraProjectIdToolSupport = AssitantToolSupport({
    toolName: 'getJiraProjectId',
    ui: InlineJiraProjectSelector
});
